import axios from "axios";
const BASE_URL = "/api/web-api/integration/nexi/charge";
function authHeaders(session_uuid) {
    return {
        "x-tenant": "null",
        "x-session-token": session_uuid,
    };
}
// Il contratto Nexi è { status, data } con errori applicativi su HTTP non-2xx
// e body { status: false, response: "<codice>", data?: ... }.
// Normalizziamo in un oggetto { code, data } così i componenti possono
// mappare il codice al messaggio i18n.
function buildError(e) {
    const payload = e && e.response ? e.response.data : undefined;
    return {
        code: payload && payload.response ? payload.response : "internal_error",
        data: payload ? payload.data : undefined,
    };
}
export default class ApiNexiCharge {
    // Lista piatta degli addebiti (default backend: ultimi 30 giorni).
    static async GetList(session_uuid, filters = {}) {
        try {
            const params = new URLSearchParams();
            if (filters.status)
                params.append("status", filters.status);
            if (filters.date_from)
                params.append("date_from", filters.date_from);
            if (filters.date_to)
                params.append("date_to", filters.date_to);
            const query = params.toString();
            const result = await axios.get(`${BASE_URL}/list${query ? "?" + query : ""}`, {
                headers: authHeaders(session_uuid),
            });
            return result.data.data;
        }
        catch (e) {
            throw buildError(e);
        }
    }
    // Ordini addebitabili per l'inserimento manuale (il backend esclude i già addebitati ok).
    static async GetEligibleOrders(session_uuid, options = {}) {
        try {
            const params = new URLSearchParams();
            if (options.day_limit)
                params.append("day_limit", String(options.day_limit));
            const query = params.toString();
            const result = await axios.get(`${BASE_URL}/eligible-orders${query ? "?" + query : ""}`, {
                headers: authHeaders(session_uuid),
            });
            return result.data.data;
        }
        catch (e) {
            throw buildError(e);
        }
    }
    // Bozza unica globale corrente (array vuoto se nessuna bozza).
    static async GetDraft(session_uuid) {
        try {
            const result = await axios.get(`${BASE_URL}/draft`, {
                headers: authHeaders(session_uuid),
            });
            return result.data.data;
        }
        catch (e) {
            throw buildError(e);
        }
    }
    // Sostituisce l'intera bozza con le righe passate.
    static async SaveDraft(session_uuid, rows) {
        try {
            await axios.post(`${BASE_URL}/draft/save`, { rows }, { headers: authHeaders(session_uuid) });
        }
        catch (e) {
            throw buildError(e);
        }
    }
    // Svuota la bozza.
    // Re-invio della mail al cliente per un addebito ok (identificato dal charge_uuid).
    static async ResendEmail(session_uuid, charge_uuid) {
        try {
            await axios.post(`${BASE_URL}/resend-email`, { charge_uuid }, {
                headers: authHeaders(session_uuid),
            });
        }
        catch (e) {
            throw buildError(e);
        }
    }
    static async DeleteDraft(session_uuid) {
        try {
            await axios.delete(`${BASE_URL}/draft`, {
                headers: authHeaders(session_uuid),
            });
        }
        catch (e) {
            throw buildError(e);
        }
    }
    // Import CSV (un subsid per riga): aggiunge alla bozza i validi, ritorna gli scarti.
    static async ImportCsv(session_uuid, file) {
        try {
            const formData = new FormData();
            formData.append("file", file);
            const result = await axios.post(`${BASE_URL}/draft/import-csv`, formData, {
                headers: {
                    ...authHeaders(session_uuid),
                    "Content-Type": "multipart/form-data",
                },
            });
            return result.data.data;
        }
        catch (e) {
            throw buildError(e);
        }
    }
    // Invio sincrono: esegue gli addebiti su Nexi e ritorna l'esito riga per riga.
    static async SendDraft(session_uuid) {
        try {
            const result = await axios.post(`${BASE_URL}/draft/send`, {}, { headers: authHeaders(session_uuid) });
            return result.data.data;
        }
        catch (e) {
            throw buildError(e);
        }
    }
}
